import type { StatusPresetMap } from './types'

export type Priority = 'highest' | 'high' | 'normal' | 'low'

export const priorityPresets: StatusPresetMap<Priority> = {
  highest: { label: 'Highest', tone: 'critical' },
  high: { label: 'High', tone: 'warning' },
  normal: { label: 'Normal', tone: 'neutral' },
  low: { label: 'Low', tone: 'muted' },
}

/**
 * Glyphs for priority — kept here so renderers don't redefine. Renderers
 * decide how to typeset (size, weight, color) via their own design system.
 */
export const priorityGlyphs: Record<Priority, string> = {
  highest: '↑',
  high: '↑',
  normal: '≡',
  low: '↓',
}
